const DETAILS_FORM_SEND = 'DETAILS_FORM_SEND';
const DETAILS_FORM_SET_SENDING = 'DETAILS_FORM_SET_SENDING';
const DETAILS_FORM_FACEBOOK_SEND = 'DETAILS_FORM_FACEBOOK_SEND';

const sendAccountForm = (email, password, agreements) => (
  {
    type: DETAILS_FORM_SEND,
    payload: { email, password, agreements }
  }
);

const sendFacebookRegistrationForm = (agreements) => ({
  type: DETAILS_FORM_FACEBOOK_SEND,
  payload: { agreements }
});

const setSendingAccountForm = (sending) => (
  {
    type: DETAILS_FORM_SET_SENDING,
    payload: { sending }
  }
);


export {
  DETAILS_FORM_SEND,
  DETAILS_FORM_SET_SENDING,
  DETAILS_FORM_FACEBOOK_SEND,
  sendFacebookRegistrationForm,
  setSendingAccountForm,
  sendAccountForm
};
